import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import exportFromJSON from "export-from-json";
import TableComponent from "./Table";
import {
  FilterComponent,
  FilterComponentt,
} from "../../components/FilterComponent";
import { ReactComponent as ExportIcon } from "../../../../../images/analytics/Export.svg";


export function OnlineTestLists({
  classes,
  headers,
  rows,
  data,
  subjectData,
  formData,
  setFormData,
}) {
  const history = useHistory();
  const handleClick = (row) => {
    history.push(
      `/analytics/tests/charts/report/${row?.testId}/${row?.subId}?subject=${row.subject}&subId=${row.subjectId}`,
    );
  };

  // /function to run for exporting practice report data
    const exportPracticeReportData = async () => {
  
      try {
        const data =
          rows &&
          rows.length &&
          rows.map((item, index) => ({
            Number: index + 1,
            "Start Date": item.startDate,
            "End Date": item.endDate,
            // "End Date": item.startedAt.split("T")[0],
            Subject: item.subject,
            Chapter: item.chapter,
            Topic: item.topic,
            "Start Time": item?.startTime,
            "Test Type": item.testType,
            "Time Spent": item.timeSpent,
            Marks: item?.marks,
            "Marks Obtained": item?.marksObtained,
  
            Correct: item.correct || 0,
            Incorrect: item.inCorrect || 0,
            Easy: item.easy || 0,
            Intermediate: item.intermediate || 0,
            Difficulty: item.difficult || 0,
            Knowledge: item.knowledge || 0,
            Understanding: item.understanding || 0,
            Analytics: item.analysis || 0,
          }));
  
        const fileName = "Online Test Details";
        const exportType = exportFromJSON.types.csv;
  
        exportFromJSON({ data, fileName, exportType });
      } catch (err) {
        console.log("Error in downloading practice report data:", err.message);
      }
    };
  return (
    <>
      <div className={classes.linkContainer}>
        <div
          className={classes.filterDiv}
          style={{ display: "flex", marginLeft: "150px", flexWrap: "wrap" }}
        >
          <FilterComponentt
            options={subjectData}
            formData={formData}
            setFormData={setFormData}
            name="subject"
          />
          <FilterComponent
            formData={formData}
            name="startDate"
            setFormData={setFormData}
            placeholder="Start Date"
          />
          <FilterComponent
            name="endDate"
            formData={formData}
            setFormData={setFormData}
            placeholder="End Date"
          />
        </div>
      </div>
      <div
        style={{
          maxWidth: "90vw",
          margin: "20px auto",
          boxShadow: "0px 0px 7px rgba(0, 0, 0, 0.37)",
          borderRadius: "19px",
          padding: "20px 10px",
          overFlowX: "auto",
        }}
        className={classes.table}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h2>Test Reports</h2>
          <div>
            <ExportIcon
              style={{ cursor: "pointer", height: "40px", width: "38px" }}
              onClick={() => exportPracticeReportData()}
            />
          </div>
        </div>
        <TableComponent
          tabHeader={headers}
          tabContent={rows}
          handleClick={handleClick}
        />
      </div>
    </>
  );
}
